import * as React from "react";

const Tabs = ({ column }) => {
  return (
    <div className="tabs">
      <div className="tabs-inner">
        <div className="tabs-buttons">
          {column?.map((tab, index) => {
            return (
              <button
                type="button"
                aria-label="tab"
                className={`tab-button ${index === 0 ? "active" : ""}`}
                data-tab={`tab-${index}`}
                dangerouslySetInnerHTML={{ __html: tab.title }}
              ></button>
            );
          })}
        </div>
        <div className="tabs-content">
          {column?.map((tab, index) => {
            return (
              <div
                className={`data-tab ${index === 0 ? "active" : ""}`}
                data-tab={`tab-${index}`}
              >
                <div
                  dangerouslySetInnerHTML={{ __html: tab.rich_text_editor }}
                ></div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Tabs;
